<div class="custom-toastr" [@toastrAnim]>
  <qds-form-message [status]="status" size="large"></qds-form-message>
  <div class="toastr-text">
    <div class="toastr-message">{{message | translate}}</div>
  </div>
  <div *ngIf="showClose" class="toastr-close" (click)="onClose()">
    <div class="close-icon">
       <qds-button icon-name="cross-large" icon-only="true" importance="subdued"></qds-button>
    </div>
  </div>
</div>
